import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

export const Wrapper = styled.div`
  background: white;
  border: 1px solid ${colors.gandalf};
  box-sizing: border-box;
  border-radius: 0.75rem;
  padding: 1.875rem;
`
export const Logo = styled.div`
  background: white;
  width: 4rem;
  height: 4rem;
  margin-right: 0.75rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 48px rgb(0 0 0 / 10%);
  padding: 0.75rem;
  margin-top: 0.75rem;

  img {
    max-width: 2.5rem;
    max-height: 2.5rem;
  }
`
export const AddButton = styled.div`
  padding: 1rem 0 0.5rem;

  img {
    margin: 0 auto;
    display: block;
    cursor: pointer;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/IntegrationBar/IntegrationBar.style.tsx